import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';
import { get, size } from 'lodash';

import { Typography, TypographyProps } from 'components/v2';

import { TypographyMessageTemplateKey_MessageTemplate$key } from './__generated__/TypographyMessageTemplateKey_MessageTemplate.graphql';

const messages = defineMessages({
  sms: {
    id: 'deprecated.fragments.TypographyMessageTemplateKey.sms',
    defaultMessage: 'SMS',
  },
  email: {
    id: 'deprecated.fragments.TypographyMessageTemplateKey.email',
    defaultMessage: 'Email',
  },
  voice: {
    id: 'deprecated.fragments.TypographyMessageTemplateKey.voice',
    defaultMessage: 'Voice',
  },
  inapp: {
    id: 'deprecated.fragments.TypographyMessageTemplateKey.inapp',
    defaultMessage: 'In-App',
  },
  chat: {
    id: 'deprecated.fragments.TypographyMessageTemplateKey.chat',
    defaultMessage: 'Chat',
  },
  fax: {
    id: 'deprecated.fragments.TypographyMessageTemplateKey.fax',
    defaultMessage: 'Fax',
  },
  whatsapp: {
    id: 'deprecated.fragments.TypographyMessageTemplateKey.whatsapp',
    defaultMessage: 'WhatsApp',
  },
  web: {
    id: 'deprecated.fragments.TypographyMessageTemplateKey.web',
    defaultMessage: 'Web',
  },
  '%future added value': {
    id: 'deprecated.fragments.TypographyMessageTemplateKey.???',
    defaultMessage: '???',
  },
});

export interface TypographyMessageTemplateKeyProps extends Omit<TypographyProps, 'classes'> {
  fragmentRef: TypographyMessageTemplateKey_MessageTemplate$key;
}

const TypographyMessageTemplateKey: React.FC<TypographyMessageTemplateKeyProps> = ({ fragmentRef, ...rest }) => {
  const messageTemplate = useFragment<TypographyMessageTemplateKey_MessageTemplate$key>(
    graphql`
      fragment TypographyMessageTemplateKey_MessageTemplate on MessageTemplate {
        key
      }
    `,
    fragmentRef,
  );

  const { formatMessage } = useIntl();

  const matches = useMemo(() => {
    if (!messageTemplate.key) {
      return [];
    }
    return messageTemplate.key.match(/messages\.(\w*).(\w*)$/);
  }, [messageTemplate.key]);

  if (size(matches) < 3) {
    return null;
  }
  return (
    <Typography {...rest}>
      {get(matches, 2)} ({formatMessage(messages[get(matches, 1) as keyof typeof messages])})
    </Typography>
  );
};

export default TypographyMessageTemplateKey;
